import React, { Component } from "react";
import SelectComponent from "../../components/Select";
import { Step3Langague } from "../../data/locale";
import InputMask from "react-input-mask";
const MaskOptions = {
  mask: "********************",
  maskChar:'',
  formatChars: {
    '*': '[A-Za-z]',
  }
}
export default class NameEngComponent extends Component {

    // _getLang(field) {
    //     const lang = this.props.langague === 2 ? "en" : "th";
    //     return Step3Langague[field][lang];
    // }

    _getLang(field) {
      const lang = this.props.labelVisa === 1 || this.props.labelLang === 2 ? "en" : "th";
      return Step3Langague[field][lang];
    }
    
    onChangeName({ key, name, value }) {
      value = value.toUpperCase();
      this.props.onChange({ key, name, value })
    }

    render() {
        const { keyIndex, titles, sInitNameEN, sFirstNameEN, sLastNameEN, onChange } = this.props;
        const key = keyIndex;
        return (
        <div className="form-group">
            <label>{this._getLang("fullnameEngVisa")}</label>
            <SelectComponent
              placeholder="Prefix"
              options={titles}
              selected={sInitNameEN}
              onChange={selected =>
                onChange({ key, name: "sInitNameEN", value: selected })
              }
            />
            <InputMask
              {...MaskOptions}
              permanents={[2, 5]}
              type="text"
              value={sFirstNameEN}
              onChange={e =>
                this.onChangeName({ key, name: e.target.name, value: e.target.value })
              }
            >
              {inputProps => (
                <input
                  id={`sFirstNameEN_${key}`}
                  {...inputProps}
                  className="form-control mt-2"
                  placeholder="FIRST NAME"
                  name="sFirstNameEN"
                />
              )}
            </InputMask>
             <InputMask
              {...MaskOptions}
              permanents={[2, 5]}
              type="text"
              value={sLastNameEN}
              onChange={e =>
                this.onChangeName({ key, name: e.target.name, value: e.target.value })
              }
            >
              {inputProps => (
                <input
                  id={`sLastNameEN_${key}`}
                  {...inputProps}
                  className="form-control mt-2"
                  placeholder="LAST NAME"
                  name="sLastNameEN"
                />
              )}
            </InputMask>
        </div>
        )
    }
}